import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"];

  connect() {
    console.log("WeekSwipeController connected");
    this.touchStartX = null;
    this.touchEndX = null;
    this.swipeThreshold = 50; // Minimum px for swipe
    this.isMobile = true; // Always enable for debugging
    if (this.isMobile) {
      this.element.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: true });
      this.element.addEventListener("touchend", this.onTouchEnd.bind(this), { passive: true });
      console.log("WeekSwipeController: touch events attached");
    }

    // Listen for Turbo page load to trigger animation
    document.addEventListener("turbo:load", this.animateCalendarFadeIn);
    document.addEventListener("turbo:frame-render", this.handleTurboFrameRender);
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.animateCalendarFadeIn);
    document.removeEventListener("turbo:frame-render", this.handleTurboFrameRender);
  }

  animateCalendarFadeIn = () => {
    const calendar = document.getElementById("week-calendar");
    if (calendar) {
      calendar.classList.add("calendar-fade-in");
      calendar.addEventListener("animationend", function handler() {
        calendar.classList.remove("calendar-fade-in");
        calendar.removeEventListener("animationend", handler);
      });
    }
  }

  onTouchStart(e) {
    // Prevent swipe if zoomed in
    if (window.visualViewport && window.visualViewport.scale > 1) {
      this.touchStartX = null;
      return;
    }
    // Only handle single-finger touches
    if (e.touches && e.touches.length > 1) {
      this.touchStartX = null;
      return;
    }
    if (e.changedTouches && e.changedTouches.length > 1) {
      this.touchStartX = null;
      return;
    }
    this.touchStartX = e.changedTouches[0].screenX;
    console.log("touchstart", this.touchStartX);
  }

  onTouchEnd(e) {
    // Prevent swipe if zoomed in
    if (window.visualViewport && window.visualViewport.scale > 1) {
      this.touchEndX = null;
      return;
    }
    // Only handle single-finger touches
    if (e.touches && e.touches.length > 1) {
      this.touchEndX = null;
      return;
    }
    if (e.changedTouches && e.changedTouches.length > 1) {
      this.touchEndX = null;
      return;
    }
    this.touchEndX = e.changedTouches[0].screenX;
    console.log("touchend", this.touchEndX);
    this.handleSwipe();
  }

  handleSwipe() {
    if (this.touchStartX === null || this.touchEndX === null) return;
    const diff = this.touchEndX - this.touchStartX;
    console.log("swipe diff", diff);
    if (Math.abs(diff) < this.swipeThreshold) return;

    if (diff < 0) {
      // Swipe left: next week
      console.log("swipe left: next week");
      this.navigateToWeek("next");
    } else {
      // Swipe right: previous week
      console.log("swipe right: previous week");
      this.navigateToWeek("prev");
    }
  }

  navigateToWeek(direction) {
    // Find the date switcher links using data attributes
    const dateSwitcher = document.querySelector('[data-date-switcher]');
    if (!dateSwitcher) {
      console.log("No date switcher found");
      return;
    }
    let link;
    if (direction === "next") {
      link = dateSwitcher.querySelector('[data-next-week-link]');
    } else {
      link = dateSwitcher.querySelector('[data-prev-week-link]');
    }
    if (link) {
      // Dispatch event to save scroll position
      const card = this.element;
      card.dispatchEvent(new CustomEvent('calendar:save-scroll', { bubbles: true }));
      console.log("Navigating to", link.href);
      Turbo.visit(link.href);
    } else {
      console.log("No link found for direction", direction);
    }
  }

  handleTurboFrameRender = (event) => {
    // Dispatch event to restore scroll position
    const card = this.element;
    card.dispatchEvent(new CustomEvent('calendar:restore-scroll', { bubbles: true }));
  }
} 